import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04e3f254"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/index.vue
// module id = 1942
// module chunks = 31